var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomev2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1316 3.66785C16.5067 3.04301 15.4937 3.04301 14.8688 3.66785L3.66882 14.8678C3.04399 15.4927 3.04399 16.5058 3.66882 17.1306C4.29366 17.7554 5.30673 17.7554 5.93157 17.1306L6.4002 16.662V27.1992C6.4002 28.0829 7.11654 28.7992 8.0002 28.7992H11.2002C12.0839 28.7992 12.8002 28.0829 12.8002 27.1992V23.9992C12.8002 23.1156 13.5165 22.3992 14.4002 22.3992H17.6002C18.4839 22.3992 19.2002 23.1156 19.2002 23.9992V27.1992C19.2002 28.0829 19.9165 28.7992 20.8002 28.7992H24.0002C24.8839 28.7992 25.6002 28.0829 25.6002 27.1992V16.662L26.0688 17.1306C26.6937 17.7554 27.7067 17.7554 28.3316 17.1306C28.9564 16.5058 28.9564 15.4927 28.3316 14.8678L17.1316 3.66785Z",
    fill: "#575860"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomev2);
export default __webpack_public_path__ + "static/media/homev2.619fdf4b2eaafd403cee164cc3bf313f.svg";
export { ForwardRef as ReactComponent };